export default {"src":"/_next/static/media/enterprise_logo.9b499a13.svg","height":67,"width":341,"blurWidth":0,"blurHeight":0};